export const INBOX_CACHE_NAME = 'inbox';
